export default __webpack_public_path__ + "static/media/AppLogo.27f2d4f5.svg";